import { i18n } from "@lingui/core";

type FuelStandard =
  | {
      text: string;
      tooltip: string;
    }
  | undefined;

/**
 * The measurement standard a car's consumption and range figures were determined under. Older cars
 * still report NEDC, and an unrecognised standard gets no suffix rather than the wrong one.
 */
export const getFuelStandard = (value?: string): FuelStandard => {
  if (value === "WLTP") {
    return {
      text: "WLTP",
      tooltip: i18n.t({
        id: "itemPageLayout.keyInfo.tooltip.wltp",
        message:
          "WLTP is a metric from when the car was new and the actual range must be seen in context of age, km, driving pattern and weather conditions",
        comment: "Tooltip for Fuel Consumption (WLTP) in ad specification",
      }),
    };
  }
  if (value === "NEDC") {
    return {
      text: "NEDC",
      tooltip: i18n.t({
        id: "itemPageLayout.keyInfo.tooltip.nedc",
        message:
          "NEDC was the pan-European measurement method used to determine the range and fuel consumption of cars before it was replaced by WLTP",
        comment: "Tooltip for Fuel Consumption (NEDC) in ad specification",
      }),
    };
  }
  return undefined;
};

/** Appends the standard to a label, e.g. `Consumption per 100 km (WLTP)`. */
export const withFuelStandard = (baseLabel: string, standard: FuelStandard) =>
  standard?.text ? `${baseLabel} (${standard.text})` : baseLabel;
